module.exports = __webpack_public_path__ + "static/media/conan-win-list.f8c2759c.jpg";